import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueApexCharts from 'vue3-apexcharts'

import './assets/libs/admin-resources/rwd-table/rwd-table.min.css'
import './assets/libs/selectize/css/selectize.bootstrap3.css'
import './assets/css/bootstrap.min.css'
import './assets/css/app.min.css'
import './assets/css/icons.min.css'
import 'element-plus/lib/theme-chalk/index.css'

//if (document.cookie.split(';').some((item) => item.includes('name='))) {
  const app = createApp(App)

  axios.defaults.baseURL = process.env.VUE_APP_API_URL_BASE
  axios.defaults.withCredentials = true
  app.use(router).use(VueApexCharts).mount('#wrapper')
//}